export enum ClosureTypeEnum {
	TEMPORARILY = "TEMPORARILY",
	DEFINITELY = "DEFINITELY"
}